import { render, staticRenderFns } from "./InputPriceCustom.vue?vue&type=template&id=b73567c0&"
import script from "./InputPriceCustom.vue?vue&type=script&lang=js&"
export * from "./InputPriceCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73567c0')) {
      api.createRecord('b73567c0', component.options)
    } else {
      api.reload('b73567c0', component.options)
    }
    module.hot.accept("./InputPriceCustom.vue?vue&type=template&id=b73567c0&", function () {
      api.rerender('b73567c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputPriceCustom.vue"
export default component.exports